export { default } from './LazyImage';
export { default as LazyImage } from './LazyImage';
export { default as LazyImageResponsive } from './LazyImageResponsive';
